export default __webpack_public_path__ + "static/media/port.71c25d07.png";